/**
 * In diesem File befinden sich alle Module für den Pflegegradrechner.
 * Modul 8 und 9 sind optional und werden aktuell nicht berücksichtigt.
 *
 * Die Antwortmöglichkeiten doppeln sich modulübergreifend, weshalb die Antworten
 * in einzelnen Arrays (answer1, ..., answer5) ausgelagert sind.
 */

const answers1 = [
  'Selbstständig',
  'Überwiegend selbstständig',
  'Überwiegend unselbstständig',
  'Unselbstständig',
];

const answers2 = [
  'Fähigkeit vorhanden',
  'Fähigkeit größtenteils vorhanden',
  'Fähigkeit kaum vorhanden',
  'Fähigkeit nicht vorhanden',
];

const answers3 = ['Nie', 'Selten', 'Häufig', 'Täglich'];

const answers4 = ['Entfällt / Selbstständig', 'Täglich', 'Wöchentlich', 'Monatlich'];

const answers5 = [
  'Selbstständig',
  'Überwiegend selbstständig',
  'Unterstützung nötig',
  'Nicht möglich',
];

const content = [
  {
    module: 1,
    headline: 'Mobilität',
    questions: [
      {
        question: 'Positionswechsel im Bett',
        info: 'Die Fähigkeit zum Einnehmen verschiedener Positionen im Bett, etwa zum Drehen um die Längsachse oder zum Aufrichten aus dem Liegen.',
        answers: answers1,
      },
      {
        question: 'Halten einer stabilen Sitzposition',
        info: 'Die Fähigkeit, sich auf einem Bett, Stuhl oder Sessel aufrecht zu halten.',
        answers: answers1,
      },
      {
        question: 'Umsetzen',
        info: 'Die Fähigkeit, von einer erhöhten Sitzfläche (Bettkante, Stuhl, Sessel, Bank, Toilette) aufzustehen, und sich auf einen Rollstuhl, Toilettenstuhl, Sessel o.ä. umzusetzen.',
        answers: answers1,
      },
      {
        question: 'Fortbewegen innerhalb des Wohnbereichs',
        info: 'Die Fähigkeit, sich innerhalb einer Wohnung oder im Wohnbereich einer Einrichtung sicher zwischen den Zimmern zu bewegen.',
        answers: answers1,
      },
      {
        question: 'Treppensteigen',
        info: 'Die Fähigkeit zum Überwinden von Treppen zwischen zwei Etagen.',
        answers: answers1,
      },
    ],
  },
  {
    module: 2,
    headline: 'Kognitive und kommunikative Fähigkeiten',
    questions: [
      {
        question: 'Erkennen von Personen aus dem näherem Umfeld',
        info: 'Die Fähigkeit, Personen aus dem näheren Umfeld wiederzuerkennen, d. h. Menschen, zu denen im Alltag regelmäßig ein direkter Kontakt besteht.',
        answers: answers2,
      },
      {
        question: 'Örtliche Orientierung',
        info: 'Die Fähigkeit, sich in der räumlichen Umgebung zurechtzufinden, andere Orte gezielt anzusteuern und zu wissen, wo man sich befindet.',
        answers: answers2,
      },
      {
        question: 'Zeitliche Orientierung',
        info: 'Die Fähigkeit, zeitliche Strukturen zu erkennen. Aufschluss darüber geben Antworten auf die Frage nach der Jahreszeit, dem Jahr, dem Monat, dem Wochentag oder der Tageszeit.',
        answers: answers2,
      },
      {
        question: 'Erinnern an wesentliche Ereignisse oder Beobachtungen',
        info: 'Die Fähigkeit, sich an kurz und auch länger zurückliegende Ereignisse oder Beobachtungen zu erinnern.',
        answers: answers2,
      },
      {
        question: 'Steuern von mehrschrittigen Alltagshandlungen',
        info: 'Die Fähigkeit, zielgerichtete Handlungen des Lebensalltags, die eine Abfolge von Teilschritten umfassen, zu steuern. Gemeint sind Handlungen, die diese Person täglich oder nahezu täglich im Lebensalltag durchführt oder durchgeführt hat, wie z.B. das komplette Ankleiden, das Kochen von Kaffee oder das Tischdecken.',
        answers: answers2,
      },
      {
        question: 'Treffen von Entscheidungen im Alltagsleben',
        info: 'Die Fähigkeit, folgerichtige und geeignete Entscheidungen im Alltagsleben zu treffen. Dazu gehört z.B. eine dem Wetter angepasste Auswahl von Kleidung oder die Entscheidung einkaufen zu gehen.',
        answers: answers2,
      },
      {
        question: 'Verstehen von Sachverhalten und Informationen',
        info: 'Die Fähigkeit, Sachverhalte zu verstehen und Informationen inhaltlich einordnen zu können. Gemeint ist zum einen die Fähigkeit, Informationen aus Gesprächen und Medien aufzunehmen und zu verstehen. Zum anderen meint es das Vermögen, Situationen einzuordnen, z.B. zu erkennen, dass gerade eine Versorgung durch eine Pflegekraft erfolgt.',
        answers: answers2,
      },
      {
        question: 'Erkennen von Risiken und Gefahren',
        info: 'Die Fähigkeit, Risiken und Gefahren zu erkennen. Dazu gehören Gefahren wie Strom- und Feuerquellen oder Barrieren und Hindernisse auf dem Fußboden bzw. auf Fußwegen.',
        answers: answers2,
      },
      {
        question: 'Mitteilen von elementaren Bedürfnissen',
        info: 'Die Fähigkeit, elementare Bedürfnisse verbal oder nonverbal mitzuteilen, sich also beispielsweise bei Hunger oder Durst, Schmerzen oder Frieren bemerkbar zu machen. Bei Sprachstörungen kann dies ggf. durch Laute, Mimik oder Gestik bzw. unter Nutzung von Hilfsmitteln erfolgen.',
        answers: answers2,
      },
      {
        question: 'Verstehen von Aufforderungen',
        info: 'Die Fähigkeit, Aufforderungen im Hinblick auf alltägliche Grundbedürfnisse zu verstehen. Zu den alltäglichen Grundbedürfnissen gehören z. B. essen, trinken, sich kleiden oder sich beschäftigen.',
        answers: answers2,
      },
      {
        question: 'Beteiligung an einem Gespräch',
        info: 'Die Fähigkeit, in einem Gespräch Gesprächsinhalte aufzunehmen, sinngerecht zu antworten und Inhalt zur Weiterführung des Gesprächs einzubringen.',
        answers: answers2,
      },
    ],
  },
  {
    module: 3,
    headline: 'Verhaltensweisen und psychische Problemlagen',
    questions: [
      {
        question: 'Motorisch geprägte Verhaltensauffälligkeiten',
        info: 'Hierzu zählen vor allem zielloses Umhergehen in der Wohnung und der Versuch desorientierter Personen, ohne Begleitung die Wohnung oder Einrichtung zu verlassen. Auch allgemeine Rastlosigkeit (z.B. ständiges Aufstehen und Hinsetzen) ist zu berücksichtigen.',
        answers: answers3,
      },
      {
        question: 'Nächtliche Unruhe',
        info: 'Gemeint sind nächtliches Umherirren oder nächtliche Unruhephasen bis hin zur Umkehr des Tag-Nacht-Rhythmus im Sinne von aktiv sein in der Nacht und schlafen während des Tages.',
        answers: answers3,
      },
      {
        question: 'Selbstschädigendes Verhalten',
        info: 'Selbstschädigendes Verhalten kann z.B. darin bestehen, sich selbst durch Gegenstände zu verletzen, ungenießbare Substanzen zu essen und zu trinken, sich selbst zu schlagen und sich selbst mit den Fingernägeln oder Zähnen zu verletzen.',
        answers: answers3,
      },
      {
        question: 'Beschädigung von Gegenständen',
        info: 'Gemeint sind hier aggressive Handlungen, die sich auf Gegenstände richten. Dazu gehört auch das Wegschieben, Wegstoßen, Treten und Schlagen von Gegenständen.',
        answers: answers3,
      },
      {
        question: 'Physisch aggressives Verhalten gegenüber anderen Personen',
        info: 'Physisch aggressives Verhalten gegenüber anderen Personen kann z.B. darin bestehen, nach Personen zu schlagen oder zu treten, andere mit Zähnen oder Fingernägeln zu verletzen, andere zu stoßen oder wegzudrängen. Auch Verletzungsversuche gegenüber anderen Personen mithilfe von Gegenständen sind gemeint.',
        answers: answers3,
      },
      {
        question: 'Verbale Aggression: Beschimpfen, Bedrohen anderer Personen',
        info: 'Dazu zählen Beleidigungen, wütendes Schimpfen, aggressives Schreien und das Bedrohen anderer Personen. Und zwar auch dann, wenn die pflegenden Personen das schon gewohnt sind und überhören.',
        answers: answers3,
      },
      {
        question: 'Andere stimmliche Auffälligkeiten',
        info: 'Darunter fallen: lautes Rufen, Schreien, Klagen ohne nachvollziehbaren Grund, vor sich hin Schimpfen, Fluchen, seltsame Laute von sich geben, ständiges Wiederholen von Sätzen und Fragen.',
        answers: answers3,
      },
      {
        question: 'Abwehr pflegerischer oder anderer unterstützender Maßnahmen',
        info: 'Hier ist die Abwehr von Unterstützung, z.B. bei der Körperpflege, die Verweigerung der Nahrungsaufnahme, der Medikamenteneinnahme oder anderer notwendiger Verrichtungen sowie die Manipulation an Vorrichtungen wie z.B. an Kathetern, Infusionen oder Sondenernährung gemeint. Dazu gehört nicht die willentliche (selbstbestimmte) Ablehnung bestimmter Maßnahmen.',
        answers: answers3,
      },
      {
        question: 'Wahnvorstellungen, Sinnestäuschungen',
        info: 'Wahnvorstellungen beziehen sich etwa auf die Vorstellung, mit Verstorbenen oder imaginären Personen in Kontakt zu stehen oder auf die Vorstellung, verfolgt, bedroht oder bestohlen zu werden.',
        answers: answers3,
      },
      {
        question: 'Ängste',
        info: 'Die Person hat starke Ängste oder Sorgen, sie erlebt Angstattacken unabhängig von der Ursache.',
        answers: answers3,
      },
      {
        question: 'Antriebslosigkeit, depressive Stimmungslage',
        info: 'Die Person zeigt kaum Interesse an der Umgebung, bringt kaum Eigeninitiative auf und benötigt Motivierung durch andere, um etwas zu tun. Sie wirkt traurig oder apathisch, möchte das Bett am liebsten nicht verlassen.',
        answers: answers3,
      },
      {
        question: 'Sozial unangemessene Verhaltensweisen',
        info: 'Sozial unangemessene Verhaltensweisen sind z.B. distanzloses Verhalten, auffälliges Einfordern von Aufmerksamkeit, sich vor anderen in unpassenden Situationen auskleiden, unangemessenes Greifen nach Personen oder unangemessene körperliche oder verbale sexuelle Annäherungsversuche.',
        answers: answers3,
      },
      {
        question: 'Sonstige unangemessene Verhaltensweisen',
        info: 'Darunter fallen z.B. Nesteln an der Kleidung, ständiges Wiederholen der gleichen Handlung, planlose Aktivitäten, Verstecken oder Horten von Gegenständen, Kotschmieren, Urinieren in die Wohnung.',
        answers: answers3,
      },
    ],
  },
  {
    module: 4,
    headline: 'Selbstversorgung',
    questions: [
      {
        question: 'Waschen des vorderen Oberkörpers',
        info: 'Darunter fallen das Waschen und Abtrocknen von Händen, Hals, Gesicht, Armen, Achselhöhlen und dem vorderen Brustbereich.',
        answers: answers1,
      },
      {
        question: 'Körperpflege im Bereich des Kopfes',
        info: 'Gemeint sind Kämmen, Zahnpflege, Prothesenreinigung und Rasieren.',
        answers: answers1,
      },
      {
        question: 'Waschen des Intimbereichs',
        info: 'Die Fähigkeit, den Intimbereich zu waschen und abzutrocknen.',
        answers: answers1,
      },
      {
        question: 'Duschen oder Baden einschließlich Waschen der Haare',
        info: 'Neben der reinen Fähigkeit, den Körper waschen zu können, sind hier auch das Ein- und Aussteigen sowie eine eventuell notwendige Überwachung während des Bades zu berücksichtigen.',
        answers: answers1,
      },
      {
        question: 'An- und Auskleiden des Oberkörpers',
        info: 'Die Fähigkeit, bereitliegende Kleidungsstücke, z.B. Unterhemd, T-Shirt, Hemd, Bluse, Pullover, Jacke, BH, Schlafanzugoberteil oder Nachthemd, an- und auszuziehen.',
        answers: answers1,
      },
      {
        question: 'An- und Auskleiden des Unterkörpers',
        info: 'Die Fähigkeit, bereitliegende Kleidungsstücke an- und ausziehen, z.B. Unterwäsche Hose, Rock, Strümpfe und Schuhe.',
        answers: answers1,
      },
      {
        question: 'Mundgerechte Zubereitung der Nahrung und Eingießen von Getränken',
        info: 'Dazu gehört das Zerteilen von belegten Brotscheiben, Obst oder anderen Speisen in mundgerechte Stücke, z.B. das Kleinschneiden von Fleisch, das Zerdrücken von Kartoffeln oder das Pürieren der Nahrung. Auch unter diese Kategorie fällt das Öffnen von Flaschenverschlüssen oder das Eingießen von Getränken aus einer Flasche oder Kanne. Möglich ist dabei die Nutzung von Hilfsmitteln wie einem Anti-Rutschbrett oder speziellem Besteck.',
        answers: answers1,
      },
      {
        question: 'Essen',
        info: 'Dies umfasst das Aufnehmen, zum Mund führen, ggf. Abbeißen, Kauen und Schlucken von mundgerecht zubereiteten Speisen, die üblicherweise mit den Fingern gegessen werden (z.B. Brot, Keksen, Obst). Außerdem umfasst es das Essen mit Gabel oder Löffel, ggf. mit speziellen Hilfsmitteln wie adaptiertem Besteck.',
        answers: answers1,
      },
      {
        question: 'Trinken',
        info: 'Die Fähigkeit, bereitstehende Getränke aufzunehmen, ggf. mit Gegenständen wie einem Strohhalm oder einem Spezialbecher mit Trinkaufsatz. Zu berücksichtigen ist auch, inwieweit die Notwendigkeit der Flüssigkeitsaufnahme auch ohne ausreichendes Durstgefühl erkannt und die empfohlene oder gewohnte Menge tatsächlich getrunken wird.',
        answers: answers1,
      },
      {
        question: 'Benutzen der Toilette oder eines Toilettenstuhls',
        info: 'Die Fähigkeit, einen Toilettengang durchzuführen. Dies umfasst den Gang zur Toilette, das Hinsetzen und Aufstehen, das Sitzen während der Blasen-oder Darmentleerung, die Intimhygiene und das Richten der Kleidung. Die Beurteilung ist auch dann vorzunehmen, wenn anstelle der Toilettenbenutzung eine Versorgung mit Hilfsmitteln erfolgt.',
        answers: answers1,
      },
      {
        question: 'Bewältigung einer Harninkontinenz und Umgang mit einem Dauerkatheter',
        info: 'Die Fähigkeit Inkontinenzprodukte sachgerecht zu verwenden, nach Bedarf zu wechseln und zu entsorgen. Dazu gehört z. B. das Entleeren eines Urinbeutels bei einem Dauerkatheter oder die Anwendung eines Urinalkondoms.',
        answers: [`Entfällt / ${answers1[0]}`, ...answers1.slice(1)],
      },
      {
        question: 'Bewältigung einer Stuhlinkontinenz und Umgang mit Stoma',
        info: 'Die Fähigkeit Stomasysteme sachgerecht zu verwenden, nach Bedarf zu wechseln und entsorgen.',
        answers: [`Entfällt / ${answers1[0]}`, ...answers1.slice(1)],
      },
      {
        question: 'Parenterale Ernährung oder Ernährung über eine Sonde',
        info: 'Das Maß, in dem die Ernährung über einen parenteralen Zugang (z. B. einen Port) oder über einen Zugang in den Magen oder Dünndarm (PEG/PEJ) erfolgt. Das kann zusätzlich zur Nahrungsaufnahme über den Mund erfolgen oder die gesamte Ernährung abdecken.',
        answers: ['Entfällt', 'Teilweise', 'Vollständig'],
      },
    ],
  },
  {
    module: 5,
    headline: 'Umgang mit krankheits- oder therapiebedingten Anforderungen und Belastungen',
    copy: 'Bitte geben Sie im Freitextfeld die Häufigkeit der notwendigen Hilfestellungen im gewählten Zeitraum an (z.B. pro Woche im Durchschnitt 3 Mal Hilfe bei der Einnahme von Medikamenten). Bitte verwenden Sie hierfür ausschließlich Ziffern von 0-9.',
    questions: [
      {
        withInputCounter: true,
        question: 'Medikation',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Injektionen',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Versorgung intravenöser Zugänge',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Absaugen oder Sauerstoffgabe',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Einreibungen, Kälte-/Wärmeanwendungen',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Messung und Deutung von Körperzuständen',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Umgang mit körpernahen Hilfsmitteln (z.B. Prothesen)',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Verbandswechsel/Wundversorgung',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Versorgung bei Stoma',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Regelmäßige Einmalkatheterisierung, Nutzung von Abführmethoden',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Therapiemaßnahmen in häuslicher Umgebung',
        answers: answers4,
      },
      {
        withInputCounter: true,
        question: 'Zeit- und technikintensive Maßnahmen in häuslicher Umgebung',
        answers: answers4,
      },
      {
        withInputCounter: true,
        hideDayOption: true,
        question: 'Arztbesuche',
        answers: answers4,
      },
      {
        withInputCounter: true,
        hideDayOption: true,
        question: 'Besuch anderer medizinischer / therapeutischer Einrichtungen',
        answers: answers4,
      },
      {
        withInputCounter: true,
        hideDayOption: true,
        question: 'Ausgedehnter Besuch medizinisch / therapeutischer Einrichtungen',
        answers: answers4,
      },
      {
        question: 'Einhaltung einer Diät oder anderer Verhaltensvorschriften',
        answers: answers1,
      },
    ],
  },
  {
    module: 6,
    headline: 'Gestaltung des Alltagslebens und sozialer Kontakte',
    questions: [
      {
        question: 'Gestaltung des Tagesablaufs und Anpassung an Veränderungen',
        info: 'Die Fähigkeit, den Tagesablauf nach individuellen Gewohnheiten und Vorlieben einzuteilen und bewusst zu gestalten und ggf. an äußere Veränderungen anpassen. Dies erfordert planerische Fähigkeiten zur Umsetzung von Alltagsroutinen. Zu beurteilen ist, ob die Person von sich aus festlegen kann, ob und welche Aktivitäten sie im Laufe des Tages durchführen möchte.',
        answers: answers1,
      },
      {
        question: 'Ruhen und Schlafen',
        info: 'Die Fähigkeit, einen Tag-Nacht-Rhythmus nach individuellen Gewohnheiten einzuhalten und für ausreichende Ruhe- und Schlafphasen zu sorgen. Dazu gehören die Fähigkeiten, die Notwendigkeit von Ruhephasen zu erkennen, sich auszuruhen und mit Phasen der Schlaflosigkeit umzugehen.',
        answers: answers1,
      },
      {
        question: 'Sich beschäftigen',
        info: 'Die Fähigkeit, verfügbare Zeit zu nutzen, um Aktivitäten durchzuführen, die den eigenen Vorlieben und Interessen entsprechen. Bei der Beurteilung geht es vorrangig darum, ob die Person in der Lage ist, geeignete Freizeitbeschäftigungen im Rahmen der eigenen Möglichkeiten auszuwählen und durchzuführen, z.B. Handarbeiten, Basteln, Lesen oder Fernsehen.',
        answers: answers1,
      },
      {
        question: 'Vornehmen von in die Zukunft gerichteten Planungen',
        info: 'Die Fähigkeit, zukünftige Ereignisse zu planen oder festzulegen. Dies kann beispielsweise anhand der Frage beurteilt werden, ob Vorstellungen oder Wünsche zu anstehenden Festlichkeiten bestehen, ob Zeitabläufe eingeschätzt werden können, ob die Person regelmäßige Termine nachvollziehen kann oder ob die körperlichen Fähigkeiten vorhanden sind, um anderen Menschen die eigene Zukunftsplanung mitzuteilen.',
        answers: answers1,
      },
      {
        question: 'Interaktion mit Personen im direkten Kontakt',
        info: 'Die Fähigkeit, im direkten Kontakt mit Angehörigen, Pflegepersonen, Mitbewohnern oder Besuchern umzugehen, Kontakt aufzunehmen, Personen anzusprechen oder auf Ansprachen zu reagieren.',
        answers: answers1,
      },
      {
        question: 'Kontaktpflege zu Personen außerhalb des direkten Umfeldes',
        info: 'Die Fähigkeit, bestehende Kontakte zu Freunden, Bekannten oder Nachbarn aufrechtzuerhalten, zu beenden oder zeitweise abzulehnen. Dazu gehört auch die Fähigkeit zur Kommunikation via Post, Telefon oder E-Mail.',
        answers: answers1,
      },
    ],
  },
  {
    module: 7,
    optional: true,
    headline: 'Außerhäusliche Aktivitäten',
    questions: [
      {
        question: 'Verlassen der Wohnung',
        info: 'Gemeint ist damit die Fähigkeit, den konkreten individuellen Wohnbereich verlassen zu können, also von den Wohnräumen bis vor das Haus zu gelangen.',
        answers: answers5,
      },
      {
        question: 'Fortbewegen außerhalb der Wohnung oder Einrichtung',
        info: 'Die Fähigkeit, sich in einem Bewegungsradius von ca. 500 m sicher und zielgerichtet zu bewegen. Gemeint ist der Umkreis der von den meisten Menschen üblicherweise zu Fuß bewältigt wird, z.B. für kurze Spaziergänge an der frischen Luft oder um Nachbarn, Bäcker etc. aufzusuchen. Die Person kann dabei ein Hilfsmittel (z.B. Stock, Rollator, Rollstuhl) nutzen.',
        answers: answers5,
      },
      {
        question: 'Nutzung öffentlicher Verkehrsmittel im Nahverkehr',
        info: 'Die Fähigkeit, in einen Bus oder eine Straßenbahn einzusteigen und an der richtigen Haltestelle wieder auszusteigen (Nahverkehr).',
        answers: answers5,
      },
      {
        question: 'Mitfahren in einem PKW/Taxi',
        info: 'Die Fähigkeit zum Ein- und Aussteigen in einen PKW und die Selbstständigkeit während der Fahrt. Eine notwendige Beaufsichtigung während der Fahrt aus Sicherheitsgründen muss entsprechend beachtet werden.',
        answers: answers5,
      },
      {
        question: 'Teilnahme an kulturellen, religiösen oder sportlichen Veranstaltungen',
        info: 'Die Fähigkeit zur Teilnahme an Veranstaltungen, bei denen in der Regel eine größere Anzahl an Personen versammelt ist. Dazu gehören beispielsweise Veranstaltungen wie Theater, Konzert, Gottesdienst oder Sportveranstaltungen. Zur Teilnahme gehört die Fähigkeit, sich längere Zeit selbstständig oder in Begleitung in einer größeren Ansammlung von Menschen aufhalten zu können.',
        answers: answers5,
      },
      {
        question: 'Besuch von Schule, Kindergarten, Arbeitsplatz, Tagespflege o.Ä.',
        info: 'Hierbei geht es um alle Lebensbereiche, die der Bildung, Arbeit und Beschäftigung dienen. Bei einigen dieser Aktivitäten übernehmen in der Regel andere Betreuungspersonen in den entsprechenden Einrichtungen beaufsichtigende und ggf. steuernde Funktionen.',
        answers: answers5,
      },
      {
        question: 'Teilnahme an sonstigen Aktivitäten mit anderen Menschen',
        info: 'Die Fähigkeit zu sozialen Aktivitäten außerhalb des engeren Familienkreises. Hierunter fallen Besuche bei Freunden oder Verwandten, Treffen mit anderen Kindern auf dem Spielplatz sowie die Teilnahme an Sitzungen in Vereinen, politischen Parteien oder Selbsthilfegruppen.',
        answers: answers5,
      },
    ],
  },
  {
    module: 8,
    optional: true,
    headline: 'Haushaltsführung',
    questions: [
      {
        question: 'Einkaufen für den täglichen Bedarf',
        info: 'Die Fähigkeit, Einkäufe für den täglichen Bedarf zu tätigen (z. B. Lebensmittel, Hygieneartikel, Zeitung).',
        answers: answers1,
      },
      {
        question: 'Zubereitung einfacher Mahlzeiten',
        info: 'Die Fähigkeit, vorbereitete Speisen zu erwärmen (auf dem Herd, im Backofen oder in der Mikrowelle) oder nach individuellen Gewohnheiten einfache Mahlzeiten zuzubereiten. Das umfasst die Zubereitung eines Heißgetränkes oder kleiner Speisen wie z.B. eines Spiegeleies. Ebenso gemeint sind das Entnehmen der Speisen aus Aufbewahrungsort und -behältnis, das Belegen von Brotscheiben oder Brötchen, das Zerkleinern von Obst, oder das Öffnen von Joghurtbechern und Konserven.',
        answers: answers1,
      },
      {
        question: 'Einfache Aufräum- und Reinigungsarbeiten',
        info: 'Die Fähigkeit zur Durchführung einfacher und körperlich leichter Haushaltstätigkeiten. Gemeint sind z.B. Tisch decken/abräumen, spülen, Spülmaschine nutzen, Wäsche falten oder Staub wischen. Für die Bewertung der Befähigung ist unerheblich, ob diese Tätigkeiten von Pflegepersonen oder Einrichtungen übernommen werden.',
        answers: answers1,
      },
      {
        question: 'Aufwendige Aufräum- und Reinigungsarbeiten',
        info: 'Die Fähigkeit, aufwendige Haushaltstätigkeiten durchzuführen. Das sind z.B. Böden wischen, Staubsaugen, Fenster putzen, Wäsche waschen, Bett beziehen, Müll entsorgen.',
        answers: answers1,
      },
      {
        question: 'Nutzung von Dienstleistungen',
        info: 'Die Fähigkeit, pflegerische oder haushaltsnahe Dienstleistungen zu organisieren und zu steuern. Das umfasst Dinge wie Pflegedienst, Haushaltshilfen, Essen auf Rädern, Wäscherei, Handwerker, Friseur oder Fußpflege.',
        answers: answers1,
      },
      {
        question: 'Regelung finanzieller Angelegenheiten',
        info: 'Die Fähigkeit, alltägliche finanzielle Angelegenheiten zu erledigen (z.B. Führen eines Girokontos, Mietzahlungen vornehmen) oder festzustellen, ob genügend Bargeld im Haus ist oder eine Rechnung bezahlt werden muss. Dazu gehört auch die Fähigkeit, aus dieser Feststellung notwendige Schritte einzuleiten oder selbst durchzuführen.',
        answers: answers1,
      },
      {
        question: 'Regelung von Behördenangelegenheiten',
        info: 'Die Fähigkeit zum Umgang mit staatlichen und kommunalen Behörden sowie Sozialversicherungsträgern. Hierzu gehört z.B. auch die Entscheidung, ob ein Antrag gestellt oder ein Behördenbrief beantwortet werden muss, und ggf. die Einleitung notwendiger Schritte.',
        answers: answers1,
      },
    ],
  },
];

export default content.filter((c) => !c.optional);
